import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../../../../store/user/reducers/user.reducer';
import {selectUser} from '../../../../../store/user/selectors/user.selectors';

@Component({
    selector: 'app-your-data',
    templateUrl: './your-data.component.html',
    styleUrls: ['../../../../../../styles/form-input.scss'],
    standalone: false
})
export class YourDataComponent {

  user$ = this.userStore.select(selectUser);

  constructor(
    private readonly userStore: Store<UserAppState>,
  ) {
  }

}
